import Seo from "../../components/Seo.tsx";
import LegalPage from "./LegalPage.tsx";

export default function Refunds() {
  return (
    <>
    <Seo title="Refund &amp; Return Policy" description="BeAdoré's refund and return policy — 14-day returns, damaged order replacement, and more." path="/refunds" noIndex />
    <LegalPage
      eyebrow="Our Promise"
      title="Refund &amp; Return Policy"
      updatedAt="April 2026"
    >
      <p>
        BeAdoré candles are hand-poured in small batches with great care. If
        something isn't right, we want to make it right. This page explains
        when and how we accept returns and issue refunds.
      </p>

      <h2>1 · Fourteen-day window</h2>
      <p>
        You may request a return within <strong>fourteen (14) days</strong> of
        the date your order is delivered. After fourteen days, all sales are
        final.
      </p>

      <h2>2 · Condition requirements</h2>
      <p>
        Returned candles must be unused, unlit, and in their original
        packaging. We cannot accept returns of candles that have been burned
        even briefly — for food-safety and cosmetic-regulation reasons. Room
        sprays must be returned sealed and unused.
      </p>

      <h2>3 · Damaged or defective orders</h2>
      <p>
        If your candle arrives damaged, broken, or defective, please email us
        at{" "}
        <a href="mailto:hello@beadorecandles.com" className="underline">
          hello@beadorecandles.com
        </a>{" "}
        within <strong>seven (7) days</strong> of delivery, with a photo of
        the damaged item and the shipping box if possible. We will send a
        replacement at no cost or issue a full refund, whichever you prefer.
      </p>

      <h2>4 · How to start a return</h2>
      <p>
        Email us at{" "}
        <a href="mailto:hello@beadorecandles.com" className="underline">
          hello@beadorecandles.com
        </a>{" "}
        with your order number (begins with <code>cs_</code>) and a short
        explanation. We will reply within two (2) business days with a return
        shipping address and instructions. You are responsible for return
        shipping costs unless the item arrived damaged or defective.
      </p>

      <h2>5 · Refunds</h2>
      <p>
        Once we receive and inspect your return, we will issue a refund to
        your original payment method within <strong>five (5) business days</strong>.
        Depending on your bank or card issuer, the refund may take an
        additional 5–10 business days to appear on your statement.
      </p>
      <p>
        The original shipping cost, if any, is non-refundable except in cases
        of damage or BeAdoré error.
      </p>

      <h2>6 · Non-returnable items</h2>
      <ul>
        <li>
          <strong>Bloomscape</strong> — our Grand Floral Wax Bouquet is made to
          order for each client. Bloomscape orders are final and non-returnable
          once production has begun. If you need to cancel before production
          begins, contact us within 48 hours of placing the order.
        </li>
        <li>
          <strong>Custom or personalized pieces</strong> — any item made to your
          bespoke specifications (colour choices, custom scent blends, engraved
          labels) is non-returnable unless defective.
        </li>
        <li>
          <strong>Digital compositions</strong> — the AI-generated horoscope
          candle reading is a free feature and is not a purchasable good.
        </li>
      </ul>

      <h2>7 · Exchanges</h2>
      <p>
        We do not currently offer direct exchanges. If you would like a
        different candle, please request a refund for your original order and
        place a new order for the item you want.
      </p>

      <h2>8 · Questions</h2>
      <p>
        We're a small team and we answer every email ourselves. If anything
        about your order feels off, write to us at{" "}
        <a href="mailto:hello@beadorecandles.com" className="underline">
          hello@beadorecandles.com
        </a>{" "}
        and we will do our best to make it right.
      </p>
    </LegalPage>
    </>
  );
}
